import React from 'react'

import { CardType } from 'types/deck'
import { DOUBLE_FACED_LAYOUTS } from 'types/card'

import Legality from 'components/cardDetailsPage/Legality/Legality'
import FromFace from 'components/cardDetailsPage/FromFace/FromFace'
import SaltMeter from 'components/cardDetailsPage/SaltMeter/SaltMeter'
import SaltScoreInfo from 'components/tooltips/SaltScoreInfo'

import styles from './cardInfo.module.scss'

type Props = {
  card: CardType
  className?: string
  flipped?: boolean
}

const CardInfo = ({ card, className = '', flipped }: Props) => {
  const isFlipCard = DOUBLE_FACED_LAYOUTS.includes(card.layout)

  return (
    <div className={`${styles.container} ${className}`}>
      {/* @ts-ignore */}
      {!isFlipCard && <FromFace card={card} />}
      {card.front && card.back && (
        <>
          <FromFace card={card.front} />
          <FromFace card={card.back} />
        </>
      )}
      <div className={styles.extraInfo}>
        <div className={styles.info}>
          <div>
            <span>Commander Gamechanger:</span> {card.gameChanger ? 'Yes' : 'No'}
          </div>
          <div>
            <span>Canadian Highlander points:</span> {card.canlanderPoints || 'None'}
          </div>
        </div>
        <div className={styles.info}>
          <div>
            <span>EDHREC Rank: {card.edhrecRank}</span>
          </div>
          <div>
            <span>Collector Number:</span> {card.collectorNumber}
          </div>
          <div>
            <span>Artist:</span> {card.artist}
          </div>
        </div>

        <div>
          <span>
            <b>EDH Salt Score</b> <SaltScoreInfo />
          </span>
          <SaltMeter salt={card.salt} />
        </div>

        <Legality legalities={card.legalities} />
      </div>
    </div>
  )
}

export default CardInfo
